/**
 * Jam (jam.dev) frontend bug reports — behind the organization's `jam`
 * feature flag. The SPA injects the recorder scripts once the flag is known
 * (`web/lib/jam/jam-loader.tsx`); the Worker never talks to Jam.
 *
 * The team id is a public identifier (it is printed into the page as
 * `<meta name="jam:team">`), one team for every environment — Jam tells
 * dev/staging/prod apart by the verified domain, not by the id.
 */
export const JAM_TEAM_ID = '5785ae45-11f6-4f76-8a38-f0d136949bdd'

/** Both scripts must come from js.jam.dev (that host is what Jam verifies). */
export const JAM_SCRIPT_URLS = [
  'https://js.jam.dev/recorder.js',
  'https://js.jam.dev/capture.js',
] as const

/** Jam drops `jam.metadata()` results larger than this once serialized. */
export const JAM_METADATA_MAX_BYTES = 10 * 1024
